import * as React from 'react'
import { StatusIdea } from 'interfaces'
import AnyCard from 'components/Card'
import LoadingCard from 'components/Card/LoadingCard'
import ScrollListener from 'components/ScrollListener'
import { ScrollConfiguration, MasonryGrid } from 'components/ContentGridView'
import { StatusesSearchProps } from './StatusesSearchProps'
import { useIntl } from 'react-intl'
import styles from 'components/ContentGridView/ContentGridView.pcss'
import { EmptyView } from 'components/EmptyView'

export interface StatusesSearchResultsProps {
  items: StatusIdea[]
  search: StatusesSearchProps
  className?: string
  scroll?: ScrollConfiguration
  itemWidth?: number
  quotesView?: boolean
  onLoadMore(): void
  onCompose?(content: StatusIdea): void | boolean
}

// eslint-disable-next-line no-magic-numbers
const LOADING_CARD_SIZES = [400, 260, 320, 380, 280, 320, 200, 320, 400, 260, 320, 380, 280, 320, 200, 320]

export const StatusesSearchResults: React.FC<StatusesSearchResultsProps> = (props) => {
  const { itemWidth, search, items, onCompose, quotesView, onLoadMore, scroll, className } = props
  const intl = useIntl()

  const renderBricksContent = () => {
    const loading = search.loading
    const results: React.ReactNode[] = []

    if (items.length !== 0) {
      const itemCards = items.map(item => (
        <AnyCard
          key={item.id}
          content={item}
          children={item}
          width={itemWidth}
          square
          onCompose={onCompose}
        />
      ))
      if (!loading) {
        return itemCards
      }

      results.push(...itemCards)
    }

    return results.concat(LOADING_CARD_SIZES.map((_, index) => (
      <LoadingCard
        key={`error-card-${index}`}
        square
        active={loading}
        width={itemWidth}
      />
    )))
  }

  const renderError = () => {
    if (search.loading || items.length > 0) {
      return null
    }

    const error = intl.formatMessage({
      id: quotesView ? 'content.msg.quotes-search-empty' : 'content.msg.status-ideas-search-empty'
    })
    const subtitle = intl.formatMessage({ id: 'content.msg.status-ideas-search-empty-subtitle' })

    return (
      <EmptyView
        key="error"
        title={error}
        subtitle={subtitle}
        contained
        top="300px"
      />
    )
  }

  const onScroll = () => {
    if (!search.loading && search.hasNextPage) {
      onLoadMore()
    }
  }

  return (
    <div className={`${styles.view} ${className || ''}`}>
      <ScrollListener
        className={styles.bricks}
        emitTreshold={250}
        emitInitial={false}
        onScroll={onScroll}
        useWindow={scroll?.useWindow}
        scrollElement={scroll?.element || document.getElementsByTagName('main')[0]}
      >
        <MasonryGrid>
          {renderBricksContent()}
        </MasonryGrid>
      </ScrollListener>
      {renderError()}
    </div>
  )
}
